import React from "react";
import {Icon, TooltipHost} from "@fluentui/react";

import styles from "./Cell.module.scss";
import type CellProps from "./CellProps";

const CellBoolean = <T,>({value}: CellProps<T>): JSX.Element => {
  return (
    <div
      className={
        value ?? false ? styles.cellBooleanValid : styles.cellBooleanInValid
      }>
      <TooltipHost>
        <Icon iconName={value ?? false ? "CheckMark" : "Error"} />
      </TooltipHost>
    </div>
  );
};

export default CellBoolean;
